





































import {Component, Vue} from 'vue-property-decorator'
import getImageSource from "@/helpers/getImageSource";
import {constants} from "@/helpers/constants";
import Cookies from "js-cookie";

@Component
export default class LoginPanel extends Vue {
  public orderStatus = constants.orderStatus

  get lang(){
    return this.$store.getters.locale
  }

  get isAuthenticated() {
    if (Cookies.get('accessToken')) {
      return true
    }
    return false
  }

  get profilePic() {
    return getImageSource('50', this.$store.getters.profilePic) || 'img/avatarDefault.png'
  }

  get orderCount(){
    return this.$store.getters.orderCounts
  }

  get userName() {
    if (this.$store.getters.nickName.trim()) {
      return this.$store.getters.nickName
    } else {
      return this.$store.getters.userName
    }
  }
  async logout() {
    await this.$store.dispatch('logout')
    await this.$store.commit('removeAllCartItems')
    this.$router.go(0)
  }
}
